import { useSelector } from "react-redux";
import { StoreType } from "../../../core/store/reducers";
import { DispSitList } from "../../models";

const getGroupLabel = (attribute?: DispSitList) => (attribute ? attribute.ftDescr : "");

export const useDispSitList = () => {
	const groups = useSelector<StoreType, DispSitList[]>(store => store.data.initialData.dispSitList);

	return [groups, getGroupLabel] as [typeof groups, typeof getGroupLabel];
};
